export default function MySQL_CREATEDB() {
  return (
    <div>
      <h2>MySQL_CREATEDB</h2>    </div>
  );
}